import { StudentThirdPartyAppCredentials } from '@coach-bot/data-access/shared/models';
import { AppAction, ContentScriptAction, InjectedScriptAction, WindowEventType } from '@shared/extension/enums';
import { dispatchAppWindowEvent } from '@shared/extension/utils/events';
import { setSentryUser } from '@shared/sentry';
import { ContentScriptStore } from '../store';

export function startHandlingServiceWorkerActions(store: ContentScriptStore): void {
  chrome.runtime.onMessage.addListener(function (request, sender, sendResponse) {
    switch (request.action) {
      case ContentScriptAction.ExtensionAuthStatusChanged: {
        if (request.detail.email !== store.profileEmail$.value) {
          store.setProfileEmail(request.detail.email);
          setSentryUser(store.profileEmail$.value);
        }
        break;
      }
      case ContentScriptAction.InitiateThirdPartyAppLogin: {
        window.postMessage(
          {
            type: WindowEventType.FromContentScript,
            action: InjectedScriptAction.InitiateThirdPartyAppLogin,
          },
          '*'
        );
        break;
      }
      case ContentScriptAction.LocalStorageChanged: {
        dispatchAppWindowEvent(new CustomEvent(AppAction.LocalStorageChanged, { detail: request.detail }));
        break;
      }
      case ContentScriptAction.OpenThirdPartyAppCredentialsPopup: {
        const credentials: StudentThirdPartyAppCredentials = request.detail.credentials;
        window.postMessage(
          {
            type: WindowEventType.FromInjectedScript,
            action: InjectedScriptAction.OpenThirdPartyAppCredentialsPopup,
            detail: {
              username: credentials.username,
              password: credentials.password,
              popupDetails: request.detail.popupDetails,
            },
          },
          location.origin
        );
        break;
      }
      case ContentScriptAction.SendDashboardMessage: {
        const { action, detail } = request.detail;
        window.postMessage(
          { type: WindowEventType.FromDashboard, action, detail },
          '*'
        );
      }
    }
    sendResponse({ status: true });
  });
}
